export default __webpack_public_path__ + "static/media/_gourmet.be22f472.png";